<template>
  <modal :title="setModel != undefined ? 'Update Code' : 'Add Code'" @close="$emit('close')">
    <template #content>
      <Form method="dialog" @submit="onSubmit" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
        <formGroup :title="'FromAddress'" v-model="model.FromAddress" :errors="errors"
          :rules="{ required: true, email: true }" @keydown.enter="save"></formGroup>
        <formGroup :title="'ToAddress'" v-model="model.ToAddress" :errors="errors"
          :rules="{ required: true, email: true }" @keydown.enter="save"></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Code" : "Add Code"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    addId: Number,
  },
  data() {
    return {
      model: {
        Id: null,
        CustomerProviderId: this.addId,
        FromAddress: "",
        ToAddress: ""
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/CustomerProviders/Senders`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The sender has been successfully updated."
                    : "The sender has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
